// src/appRWAPromo/utils/deeplinks.js
export function smartOpen(urlWeb, urlDeep) {
  if (!urlDeep) {
    window.open(urlWeb, '_blank', 'noopener,noreferrer');
    return;
  }
  const isMobile = /Android|webOS|iPhone|iPad|iPod|IEMobile|Opera Mini/i.test(navigator.userAgent);

  if (isMobile) {
    const deepWin = window.open(urlDeep);
    setTimeout(() => { try { deepWin?.close?.(); } catch {} window.location.href = urlDeep; }, 0);
    setTimeout(() => {
      if (document.visibilityState !== 'hidden') {
        window.open(urlWeb, '_blank', 'noopener,noreferrer');
      }
    }, 700);
  } else {
    window.open(urlWeb, '_blank', 'noopener,noreferrer');
  }
}

// Собираем правильные ссылки для Telegram по данным квеста
export function buildTelegramOpen(tg = {}) {
  if (tg.inviteLink) {
    const m = String(tg.inviteLink).match(/t\.me\/(?:\+|joinchat\/)([A-Za-z0-9_-]+)/i);
    const code = m?.[1];
    return { webUrl: tg.inviteLink, deepLink: code ? `tg://join?invite=${code}` : tg.inviteLink };
  }
  if (tg.chatUsername) {
    return {
      webUrl: `https://t.me/${tg.chatUsername}`,
      deepLink: `tg://resolve?domain=${tg.chatUsername}`,
    };
  }
  const absId = String(tg.chatId || '').replace('-100', '').replace(/^-/, '');
  return {
    webUrl: absId ? `https://t.me/c/${absId}` : 'https://web.telegram.org/',
    deepLink: tg.chatId ? `tg://openmessage?chat_id=${tg.chatId}` : undefined,
  };
}

